import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';

const EditSpeaker = () => {
  const [uploading, setIsUploading] = useState(false);
    const { SetNotification, API } = useStateContext();
  const [loadedImage , setloadedImage ] = useState(null) ; 
  const [updateImage, setUpdateImage] = useState(null) ; 
  const { id } = useParams();
  const navigate = useNavigate();

  const [speaker, setSpeaker] = useState({
    name: '',
    ar_name: '',
    title: '',
    ar_title: '',
    description: '',
    ar_description: '',
    image: null, // Store the image file object
  });

  useEffect(() => {
    const fetchSpeaker = async () => {
      try {
        await AxiosClient.get(`/speakers/${id}`).then((response) =>{
          setloadedImage (API + response.data.image); 
          setSpeaker (response.data) ; 
        })
       
      
      ; 
      } catch (error) {
        console.error('Error fetching speaker:', error);
        // Handle error (e.g., show notification)
      }
    };

    fetchSpeaker();
  }, [id, API]);

  const nameRef = useRef(null);
  const ar_nameRef = useRef(null);
  const titleRef = useRef(null);
  const ar_titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const ar_descriptionRef = useRef(null);
  const imageRef = useRef(null); // Ref to store the uploaded image input element


  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setUpdateImage( e.target.files[0]);

    const reader = new FileReader();

    reader.onload = (event) => {
      setloadedImage(event.target.result);
    };

    reader.readAsDataURL(selectedImage);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading(true);
   
    const payload = {
      name: nameRef.current.value,
      ar_name: ar_nameRef.current.value,
      title: titleRef.current.value,
      ar_title: ar_titleRef.current.value,
      description: descriptionRef.current.value,
      ar_description: ar_descriptionRef.current.value,
    };
    if (updateImage ) {
      Object.assign(payload, { image: updateImage }); 
      console.log("this payload") ;
      console.log(payload);
      console.log(payload);

      await AxiosClient.post(`/speakers/update/${id}`, payload , {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      } ).then( (response ) => {
        console.log (response) ; 
        if (response.status == 200) {
          SetNotification('Speaker updated successfully', 'success');
          navigate(-1); // Navigate back to the previous page
        }else 
        console.log (response) ; 
      }) ;
    }
    else { 
      try {
        await AxiosClient.put(`/speakers/${id}`, payload ).then( (response ) => {
          console.log (response) ; 
          if (response.status == 200) {
            SetNotification('Speaker updated successfully', 'success');
            navigate(-1); // Navigate back to the previous page
          }else 
          console.log (response) ; 
        }) ; 
       
  
        
      } catch (error) {
        console.error('Error updating speaker:', error);
        if (error.response && error.response.data && error.response.data.message) {
          SetNotification(error.response.data.message, 'danger');
        } else {
          SetNotification('An error occurred while updating speaker.', 'danger');
        }
      } finally {
        setIsUploading(false);
      }
    }
    
   
  };

  return (
    <div className="m-4">
      <form className="form-group">
      {/* Input fields for English */}
<h5>Name (English)</h5>
<div className="input-group input-group-outline mb-3">
  <input
    type="text"
    className="form-control"
    placeholder="Enter name in English"
    ref={nameRef}
    defaultValue={speaker.name} // Populate with current speaker's name
  />
</div>

<h5>Title (English)</h5>
<div className="input-group input-group-outline mb-3">
  <input
    type="text"
    className="form-control"
    placeholder="Enter title in English"
    ref={titleRef}
    defaultValue={speaker.title} // Populate with current speaker's title
  />
</div>

<h5>Description (English)</h5>
<div className="input-group input-group-outline mb-3">
  <textarea
    className="form-control"
    placeholder="Enter description in English"
    rows={5}
    ref={descriptionRef}
    defaultValue={speaker.description} // Populate with current speaker's description
  />
</div>

{/* Input fields for Arabic */}
<h5>Name (Arabic)</h5>
<div className="input-group input-group-outline mb-3">
  <input
    type="text"
    className="form-control"
    dir="rtl"
    placeholder="أدخل الاسم باللغة العربية"
    ref={ar_nameRef}
    defaultValue={speaker.ar_name} // Populate with current speaker's Arabic name
  />
</div>

<h5>Title (Arabic)</h5>
<div className="input-group input-group-outline mb-3">
  <input
    type="text"
    className="form-control"
    dir="rtl"
    placeholder="أدخل العنوان باللغة العربية"
    ref={ar_titleRef}
    defaultValue={speaker.ar_title} // Populate with current speaker's Arabic title
  />
</div>

<h5>Description (Arabic)</h5>
<div className="input-group input-group-outline mb-3">
  <textarea
    className="form-control"
    dir="rtl"
    placeholder="أدخل الوصف باللغة العربية"
    rows={5}
    ref={ar_descriptionRef}
    defaultValue={speaker.ar_description} // Populate with current speaker's Arabic description
  />
</div>


        <h5>Image</h5>
        <div className="w-full flex flex-wrap items-center">
          <label htmlFor="imageUpload" className="w-full block mb-2 font-medium text-gray-700 m-2">
            Speaker Image:
          </label>
          <input
            type="file"
            id="imageUpload"
            accept="image/*"
            onChange={handleImageChange}
            className="py-2 m-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        {speaker.image && (
          <img
            src={loadedImage}
            alt="Uploaded"
            style={{ maxWidth: '250px', maxHeight: '250px' }}
            className="w-full object-contain mb-w-100 text-center"
          />
        )}
       
      <br/>
        {uploading ? (
          <h4 className="text-red">Loading...</h4>
        ) : (
          <button onClick={handleSubmit} className="btn btn-info mt-3 px-5">
            <i className="material-icons mx-2">edit</i>
            Update
          </button>
        )}
      </form>
    </div>
  );
};

export default EditSpeaker;
